import { motion } from "framer-motion";
import { waLink, RESPONSE_TIME } from "../config/site";

// Icône WhatsApp (officielle, SVG inline — lucide ne la fournit pas).
export function WhatsAppIcon({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M12.04 2a9.9 9.9 0 0 0-8.5 14.96L2 22l5.2-1.5A9.9 9.9 0 1 0 12.04 2Zm0 1.8a8.1 8.1 0 1 1-4.13 15.07l-.3-.18-3.06.88.9-2.98-.2-.31A8.1 8.1 0 0 1 12.04 3.8Zm-3.2 3.62c-.18 0-.47.07-.72.34-.24.27-.94.92-.94 2.24 0 1.32.96 2.6 1.1 2.78.13.18 1.88 3 4.65 4.08 2.3.9 2.77.72 3.27.68.5-.05 1.6-.65 1.83-1.28.22-.63.22-1.17.15-1.28-.06-.11-.24-.18-.5-.31-.27-.14-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.14-.18.27-.7.87-.86 1.05-.16.18-.32.2-.59.07a7.4 7.4 0 0 1-2.2-1.36 8.2 8.2 0 0 1-1.52-1.9c-.16-.27 0-.41.12-.55.12-.12.27-.32.4-.48.14-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.13-.6-1.45-.83-1.98-.2-.48-.43-.5-.6-.5h-.56Z" />
    </svg>
  );
}

const track = (label) => {
  if (typeof window !== "undefined" && window.plausible) {
    window.plausible("Clic WhatsApp", { props: { bouton: label } });
  }
};

const base =
  "group relative inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-full font-display font-semibold tracking-tight transition-[transform,box-shadow,background-color] duration-300 will-change-transform";

const variants = {
  primary:
    "bg-electric text-white shadow-[0_10px_30px_-8px_rgba(22,119,255,0.55)] hover:-translate-y-0.5 hover:bg-electric-600 hover:shadow-[0_18px_40px_-10px_rgba(22,119,255,0.6)]",
  dark: "bg-nuit-900 text-white hover:-translate-y-0.5 hover:bg-nuit-800 shadow-[0_10px_30px_-10px_rgba(7,26,45,0.6)]",
  outlineLight:
    "border border-white/30 text-white hover:border-white/70 hover:-translate-y-0.5 backdrop-blur-sm",
  outlineDark:
    "border border-nuit-900/20 text-nuit-900 hover:border-nuit-900/60 hover:-translate-y-0.5",
};

const sizes = {
  md: "px-6 py-3.5 text-base",
  lg: "px-8 py-4.5 text-lg py-4",
  sm: "px-5 py-2.5 text-sm",
};

export function CtaWhatsApp({
  label = "Commander ma carte sur WhatsApp",
  message,
  variant = "primary",
  size = "md",
  className = "",
  testid = "cta-whatsapp",
  showResponseTime = false,
}) {
  return (
    <span className={`inline-flex flex-col items-center gap-2 ${className}`}>
      <motion.a
        href={waLink(message)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        onClick={() => track(label)}
        className={`${base} ${variants[variant]} ${sizes[size]} overflow-hidden`}
        whileTap={{ scale: 0.97 }}
      >
        <span className="pointer-events-none absolute inset-0 -translate-x-full bg-white/15 transition-transform duration-500 group-hover:translate-x-0" />
        <WhatsAppIcon className="h-5 w-5 shrink-0" />
        <span>{label}</span>
      </motion.a>
      {showResponseTime && (
        <span className="inline-flex items-center gap-1.5 text-xs font-medium text-current opacity-80">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
          </span>
          {RESPONSE_TIME}
        </span>
      )}
    </span>
  );
}
